var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.showAlertContainer,
          expression: "showAlertContainer",
        },
      ],
      staticClass: "alert__container",
    },
    _vm._l(_vm.alerts_arr, function (item, index) {
      return _c(
        "b-alert",
        {
          key: item.id,
          staticClass: "alert",
          class: item.success ? "alert__primary" : "alert__danger",
          attrs: { show: "", variant: item.success ? "primary" : "danger" },
        },
        [_vm._v("\n        " + _vm._s(item.message) + "\n    ")]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }